var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30603 8.8548L5.96638 5.19446C6.074 5.08684 6.074 4.91272 5.96638 4.80554L2.30603 1.1452C2.09911 0.938272 2.09911 0.60273 2.30603 0.395367L2.54621 0.155194C2.75313 -0.0517315 3.08867 -0.0517315 3.29604 0.155194L7.75827 4.61743C7.96957 4.82873 7.96957 5.17127 7.75827 5.38257L3.29604 9.84481C3.08911 10.0517 2.75357 10.0517 2.54621 9.84481L2.30603 9.60463C2.09911 9.39771 2.09911 9.06217 2.30603 8.8548Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/ArrowRightIcon.ec6d2b99585e898edc6db1a326feae43.svg";
export { ForwardRef as ReactComponent };